import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";

let viewport = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');

if (!viewport) {
  viewport = document.createElement("meta");
  viewport.name = "viewport";
  document.head.appendChild(viewport);
}

viewport.content =
  "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);